import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Navbar from './components/Navbar';
import About from './pages/About';
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import TandC from './pages/TandC';
import Header from './components/Header';
import Footer from './components/Footer'; // ✅ Import Footer

function App() {
  return (
    <BrowserRouter>
      {/* Flex container to keep footer at bottom */}
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#3b3b3b', // optional to match your theme
        }}
      >
        <div style={{ flex: 1 }}>
          <Header />
          <Navbar />
          <Routes>
            {/* Home page */}
            <Route path="/" element={<Home />} />

            {/* Your pages */}
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/T&Cs" element={<TandC />} />

            {/* Catch-all: redirect unknown paths to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>

        {/* ✅ Footer visible on every page */}
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;

